// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daily-report {
  padding: 0;
}

.dr-tabs {
  display: flex;
  gap: 4px;
  background: white;
  padding: 6px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: fit-content;
}

.dr-tab {
  padding: 10px 22px;
  border: none;
  background: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dr-tab.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.35);
}

.dr-tab:hover:not(.active) {
  background: #f3f4f6;
  color: #374151;
}

/* Submit Form */
.dr-form-card {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  max-width: 700px;
}

.dr-form-card h3 {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dr-form-card h3 i {
  color: #667eea;
}

.dr-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.dr-form-grid .full-width {
  grid-column: 1 / -1;
}

.dr-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dr-form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.dr-form-group input,
.dr-form-group select,
.dr-form-group textarea {
  padding: 10px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: #f9fafb;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  font-family: inherit;
  resize: vertical;
}

.dr-form-group input:focus,
.dr-form-group select:focus,
.dr-form-group textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.12);
  background: white;
}

.dr-submit-btn {
  margin-top: 24px;
  padding: 12px 32px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: opacity 0.2s, transform 0.1s;
}

.dr-submit-btn:hover {
  opacity: 0.9;
}

.dr-submit-btn:active {
  transform: scale(0.98);
}

.dr-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Alert */
.dr-alert {
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dr-alert.success {
  background: #d1fae5;
  color: #065f46;
}

.dr-alert.error {
  background: #fee2e2;
  color: #991b1b;
}

.dr-alert.info {
  background: #dbeafe;
  color: #1e40af;
}

/* History / Table */
.dr-filters {
  background: white;
  padding: 20px 24px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dr-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dr-filter-group label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.dr-filter-group input,
.dr-filter-group select {
  padding: 8px 12px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: #f9fafb;
  outline: none;
  min-width: 160px;
}

.dr-filter-group input:focus,
.dr-filter-group select:focus {
  border-color: #667eea;
  background: white;
}

.dr-table-wrapper {
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
  overflow: hidden;
}

.dr-table {
  width: 100%;
  border-collapse: collapse;
}

.dr-table thead tr {
  background: #f8fafc;
  border-bottom: 2px solid #e5e7eb;
}

.dr-table th {
  padding: 14px 16px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.dr-table td {
  padding: 14px 16px;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: top;
}

.dr-table tbody tr:hover {
  background: #fafafe;
}

.dr-table tbody tr:last-child td {
  border-bottom: none;
}

.dr-report-preview {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #6b7280;
  font-size: 13px;
}

/* Status badges */
.dr-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.dr-badge.submitted {
  background: #fef3c7;
  color: #92400e;
}

.dr-badge.reviewed {
  background: #dbeafe;
  color: #1e40af;
}

.dr-badge.approved {
  background: #d1fae5;
  color: #065f46;
}

/* Action buttons */
.dr-btn-review {
  padding: 6px 14px;
  border: none;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: opacity 0.2s;
}

.dr-btn-review.approve {
  background: #d1fae5;
  color: #065f46;
}

.dr-btn-review.review {
  background: #dbeafe;
  color: #1e40af;
}

.dr-btn-review:hover {
  opacity: 0.8;
}

.dr-btn-view {
  padding: 6px 10px;
  border: none;
  background: #f3f4f6;
  border-radius: 7px;
  cursor: pointer;
  color: #374151;
  font-size: 13px;
  transition: background 0.2s;
}

.dr-btn-view:hover {
  background: #e5e7eb;
}

/* Pagination */
.dr-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  background: white;
  margin-top: 0;
}

.dr-pagination span {
  font-size: 13px;
  color: #6b7280;
}

.dr-pagination-btns {
  display: flex;
  gap: 6px;
}

.dr-pagination-btns button {
  padding: 6px 14px;
  border: 1.5px solid #e5e7eb;
  background: white;
  border-radius: 7px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.dr-pagination-btns button:hover:not(:disabled) {
  border-color: #667eea;
  color: #667eea;
}

.dr-pagination-btns button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Modal / Detail View */
.dr-detail-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.dr-detail-modal {
  background: white;
  border-radius: 18px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.dr-detail-modal h3 {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dr-detail-modal h3 button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #9ca3af;
  line-height: 1;
}

.dr-detail-row {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  align-items: flex-start;
}

.dr-detail-label {
  min-width: 120px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}

.dr-detail-value {
  font-size: 14px;
  color: #111827;
  flex: 1 1;
  line-height: 1.6;
  white-space: pre-wrap;
}

.dr-review-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 2px solid #f3f4f6;
}

.dr-review-section h4 {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 16px;
}

.dr-empty {
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.dr-empty i {
  font-size: 40px;
  margin-bottom: 12px;
  display: block;
}

.dr-empty p {
  font-size: 15px;
}

.dr-loading {
  text-align: center;
  padding: 60px;
  color: #6b7280;
}

.dr-loading i {
  font-size: 28px;
  margin-bottom: 10px;
  display: block;
}

@media (max-width: 768px) {
  .dr-form-grid {
    grid-template-columns: 1fr;
  }

  .dr-filters {
    flex-direction: column;
    align-items: stretch;
  }

  .dr-filter-group input,
  .dr-filter-group select {
    min-width: unset;
    width: 100%;
  }

  .dr-table th:nth-child(n+5),
  .dr-table td:nth-child(n+5) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DailyReport.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".daily-report {\n  padding: 0;\n}\n\n.dr-tabs {\n  display: flex;\n  gap: 4px;\n  background: white;\n  padding: 6px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  width: fit-content;\n}\n\n.dr-tab {\n  padding: 10px 22px;\n  border: none;\n  background: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dr-tab.active {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.35);\n}\n\n.dr-tab:hover:not(.active) {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* Submit Form */\n.dr-form-card {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  max-width: 700px;\n}\n\n.dr-form-card h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dr-form-card h3 i {\n  color: #667eea;\n}\n\n.dr-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.dr-form-grid .full-width {\n  grid-column: 1 / -1;\n}\n\n.dr-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dr-form-group label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.dr-form-group input,\n.dr-form-group select,\n.dr-form-group textarea {\n  padding: 10px 14px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #111827;\n  background: #f9fafb;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  outline: none;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.dr-form-group input:focus,\n.dr-form-group select:focus,\n.dr-form-group textarea:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.12);\n  background: white;\n}\n\n.dr-submit-btn {\n  margin-top: 24px;\n  padding: 12px 32px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.dr-submit-btn:hover {\n  opacity: 0.9;\n}\n\n.dr-submit-btn:active {\n  transform: scale(0.98);\n}\n\n.dr-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Alert */\n.dr-alert {\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dr-alert.success {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.dr-alert.error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.dr-alert.info {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n/* History / Table */\n.dr-filters {\n  background: white;\n  padding: 20px 24px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.dr-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.dr-filter-group label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.dr-filter-group input,\n.dr-filter-group select {\n  padding: 8px 12px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #111827;\n  background: #f9fafb;\n  outline: none;\n  min-width: 160px;\n}\n\n.dr-filter-group input:focus,\n.dr-filter-group select:focus {\n  border-color: #667eea;\n  background: white;\n}\n\n.dr-table-wrapper {\n  background: white;\n  border-radius: 14px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);\n  overflow: hidden;\n}\n\n.dr-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.dr-table thead tr {\n  background: #f8fafc;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.dr-table th {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.dr-table td {\n  padding: 14px 16px;\n  font-size: 14px;\n  color: #374151;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: top;\n}\n\n.dr-table tbody tr:hover {\n  background: #fafafe;\n}\n\n.dr-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dr-report-preview {\n  max-width: 240px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n/* Status badges */\n.dr-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.dr-badge.submitted {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.dr-badge.reviewed {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.dr-badge.approved {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n/* Action buttons */\n.dr-btn-review {\n  padding: 6px 14px;\n  border: none;\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  transition: opacity 0.2s;\n}\n\n.dr-btn-review.approve {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.dr-btn-review.review {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.dr-btn-review:hover {\n  opacity: 0.8;\n}\n\n.dr-btn-view {\n  padding: 6px 10px;\n  border: none;\n  background: #f3f4f6;\n  border-radius: 7px;\n  cursor: pointer;\n  color: #374151;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.dr-btn-view:hover {\n  background: #e5e7eb;\n}\n\n/* Pagination */\n.dr-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-top: 1px solid #e5e7eb;\n  background: white;\n  margin-top: 0;\n}\n\n.dr-pagination span {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.dr-pagination-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.dr-pagination-btns button {\n  padding: 6px 14px;\n  border: 1.5px solid #e5e7eb;\n  background: white;\n  border-radius: 7px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dr-pagination-btns button:hover:not(:disabled) {\n  border-color: #667eea;\n  color: #667eea;\n}\n\n.dr-pagination-btns button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Modal / Detail View */\n.dr-detail-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.dr-detail-modal {\n  background: white;\n  border-radius: 18px;\n  padding: 32px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 85vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.dr-detail-modal h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dr-detail-modal h3 button {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #9ca3af;\n  line-height: 1;\n}\n\n.dr-detail-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n  align-items: flex-start;\n}\n\n.dr-detail-label {\n  min-width: 120px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.dr-detail-value {\n  font-size: 14px;\n  color: #111827;\n  flex: 1;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.dr-review-section {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 2px solid #f3f4f6;\n}\n\n.dr-review-section h4 {\n  font-size: 15px;\n  font-weight: 700;\n  color: #374151;\n  margin-bottom: 16px;\n}\n\n.dr-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: #9ca3af;\n}\n\n.dr-empty i {\n  font-size: 40px;\n  margin-bottom: 12px;\n  display: block;\n}\n\n.dr-empty p {\n  font-size: 15px;\n}\n\n.dr-loading {\n  text-align: center;\n  padding: 60px;\n  color: #6b7280;\n}\n\n.dr-loading i {\n  font-size: 28px;\n  margin-bottom: 10px;\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .dr-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dr-filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .dr-filter-group input,\n  .dr-filter-group select {\n    min-width: unset;\n    width: 100%;\n  }\n\n  .dr-table th:nth-child(n+5),\n  .dr-table td:nth-child(n+5) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
